export const Marquee = ({ items, dark = false }) => (
  <div
    data-testid={dark ? "marquee-dark" : "marquee-orange"}
    className={`relative overflow-hidden border-y py-4 ${
      dark
        ? "border-white/10 bg-roch-navy text-white/80"
        : "border-roch-orange bg-roch-orange text-roch-navy"
    }`}
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span
              key={i}
              className="mx-8 flex items-center gap-16 font-display text-base font-extrabold uppercase tracking-[0.08em] sm:text-lg"
            >
              {item}
              <span className={`inline-block h-1.5 w-1.5 rounded-full ${dark ? "bg-roch-orange" : "bg-roch-navy/60"}`} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
